module.exports = __webpack_public_path__ + "static/media/fa-light-300.9b8974e9.ttf";